import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Button from 'common/components/Button';
import { formatPrice } from 'common/functions';
import { Link } from 'react-router-dom';
import { utils, } from 'styles';

type Props = {
    setOpen: Function;
    sumPrice: number;
};

const genericStyles = {
    textDecoration: 'none',
};

const ShoppingCartContent: React.FC<Props> = ({ setOpen, sumPrice }) => {
    const noUnderline = utils.makeGenericStyles(genericStyles);

    const handleClick = () => {
        setOpen(false);
    };

    return (
        <Grid container direction="column" alignItems="flex-end">
            <Grid item xs={12}>
                <Typography paragraph>Razem: {formatPrice(sumPrice)}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Link to="/checkout/cart"
                      className={noUnderline.root}>
                    <Button onClick={handleClick}>Przejdź do koszyka</Button>
                </Link>
            </Grid>
        </Grid>
    );
};

export default ShoppingCartContent;
